
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import style from '../../styles/content.module.css'

import { getLayout, LayoutContext } from '../../components/sg/Layout'
import Header from '../../components/Header'
import useTranslation from 'next-translate/useTranslation'
import classNames from 'classnames/bind'
import Link from 'next/link'
import Image from 'next/image'
import { useLivePrice } from '../../hooks/usePrices'
import resolveProductUnit from '../../helpers/resolveProductUnit'
import Footer from '../../components/sg/Footer'
import Cards from '../../components/sg/Cards'
import Head from 'next/head'
import { useContext } from 'react'
import { useRouter } from 'next/router'
export default function About () {
  const { t } = useTranslation('main')
  const c = classNames.bind(style)
  const router = useRouter()
  const { locale } = router
  const [layoutContext] = useContext(LayoutContext)
  const { currency } = layoutContext
  const { productPriceResolution } = resolveProductUnit('gram', 1)
  const { price: { value: spotPrice } } = useLivePrice(currency, 'gld', productPriceResolution)

  return (
    <>
      <Head>
        <title>{t('about-pagetitle')}</title>
      </Head>
      <Header showLogo />
      <div className={c('content')}>
        <div className={c('hero')}>
          <Image src='/images/contact_photo.jpg' layout='fill' alt='Render of Silver Bullion Shop at Millenia Walk' />
        </div>
        <div className={c('inner')}>
          <div className={c('single')} data-meh={spotPrice + locale}>
            <h3>{t('about-title')}</h3>
            <br />
            <p>
              {t('about-body-1')}
            </p>
            <p style={{ textAlign: 'center' }}><a href='https://www.silverbullion.com.sg' target='_blank' rel='noopener noreferrer'>{t('about-learnmore-link')}</a></p>
            <p>
              {t('about-body-2')}
            </p>
            <br />
            <p style={{ textAlign: 'center' }}>
              <Link href='/explore'><button className='light'>{t('about-explore-link')}</button></Link>
              <Link href='/sg/contact'><button className='light'>{t('about-contact-link')}</button></Link>
            </p>
          </div>
          <div className={c('promotion')}>
            {t('banner-mission-1')}<br />
            {t('banner-mission-2')}<br />
            <br />
            <br />
            <Link href='/signup'>
              <button className='goldenshimmer' title={t('banner-signup-button-title')}>{t('banner-signup-button')}</button>
            </Link>
            <span className={c('termsnote')}>{t('banner-signup-subtext')}</span>
          </div>
        </div>
      </div>
      <Cards />
      <Footer />
    </>
  )
}

About.getLayout = getLayout


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/sg/about',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  